import React from 'react';
import { useSelector } from 'react-redux';
import { ErrorState } from '../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import {
  whatIfsBodySelector,
  whatIfsOrDefaultSelector,
} from '../../../../../../WhatIfs/WhatIfsSelector';
import { SocialSecurityLoading } from './SocialSecurity.loading';
import { SocialSecurityTable } from './components/SocialSecurityTable/SocialSecurityTable';
import { useSocialSecurity } from './useSocialSecurity';
import { useSocialSecuritySuccessProbabilities } from './useSocialSecuritySuccessProbabilities';
import { useSelectedPlan } from '../../../../../../PlanSelectionOPL/hooks/useSelectedPlan';

export const SocialSecurity = () => {
  const whatIfsBody = useSelector(whatIfsBodySelector);
  const isWhatIfsOpen = useSelector(whatIfsOrDefaultSelector).open;
  const isWhatIfsActive = isWhatIfsOpen && whatIfsBody != null;

  const defaultPlan = useSelectedPlan();

  const { isFetching, data, error, refetch } = useSocialSecurity({
    isWhatIfsActive,
    whatIfsBody,
    planName: defaultPlan?.name,
  });

  const {
    data: successProbabilitiesData,
    loadingStates,
    errors,
  } = useSocialSecuritySuccessProbabilities({ isWhatIfsActive, whatIfsBody });

  if (isFetching && !data) {
    return <SocialSecurityLoading />;
  }

  if (error) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" py="24" height="100%">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <SocialSecurityTable
      data={data}
      successProbabilitiesData={successProbabilitiesData}
      loadingStates={loadingStates}
      errors={errors}
    />
  );
};
